import '@/libs/veeValidate'

import { definePreset } from '@primeuix/themes'
import Aura from '@primeuix/themes/aura'
import { createPinia } from 'pinia'
import PrimeVue from 'primevue/config'
import ConfirmationService from 'primevue/confirmationservice'
import ToastService from 'primevue/toastservice'
import Tooltip from 'primevue/tooltip'
import { createApp, nextTick } from 'vue'

import App from './App.vue'
import { registerLayouts } from './layouts'
import router from './router'

import { PredefinedText } from '@/enums/common.ts'
import { parseError } from '@/libs/error.ts'
import i18n from '@/libs/i18n'
import { createSentry } from '@/libs/sentry.ts'
import './assets/main.css'
import { PrintError } from '@/libs/toast.ts'
import { useAppStore } from '@/stores/app.ts'

export const $NilObjectId = '000000000000000000000000'

const Noir = definePreset(Aura, {
    semantic: {
        primary: {
            50: 'var(--color-primary-50)',
            100: 'var(--color-primary-100)',
            200: 'var(--color-primary-200)',
            300: 'var(--color-primary-300)',
            400: 'var(--color-primary-400)',
            500: 'var(--color-primary-500)',
            600: 'var(--color-primary-600)',
            700: 'var(--color-primary-700)',
            800: 'var(--color-primary-800)',
            900: 'var(--color-primary-900)',
            950: 'var(--color-primary-950)'
        }
    }
})

const initialize = async() => {
    const app = createApp(App)
    registerLayouts(app)
    app.use(createPinia())
    app.use(i18n)
    app.use(ConfirmationService)
    app.use(ToastService)
    app.directive('tooltip', Tooltip)
    app.use(PrimeVue, {
        theme: {
            preset: Noir,
            options: {
                cssLayer: {
                    name: 'primevue',
                    order: 'theme, base, primevue'
                },
                darkModeSelector: '.dark'
            }
        }
    })

    let loadUserDataError = null
    try {
        const appStore = useAppStore()
        if (appStore.isLoggedIn()) {
            await appStore.loadUserData()
        }
    } catch(e) {
        // toast service gets initialized after app.mount(), toast message cannot be printed here
        loadUserDataError = e
        console.log(e)
    }

    createSentry(app)
    app.use(router)
    app.mount('#app')

    if (loadUserDataError) {
        await nextTick() // without nextTick(), toast is displayed below AppToolbar.
        PrintError(parseError(loadUserDataError, PredefinedText.value.ErrorLoadData))
    }
}

// top level await is not supported
void initialize()
